import cognitoAuth from '../../utils/cognitoAuth.mjs';
import toResponse from './toRes.mjs';
import salesforceConfig from '../../utils/salesforceConfig.mjs';
import requiresEmployeeToken from '../../utils/tokenAuth.mjs';

const fetchContacts = async(accountId, uuid, employee, isMockMode = false) => {
  const token = await cognitoAuth();
  const employeeRefreshToken = await requiresEmployeeToken(uuid, employee, false);
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }

  const mockResponse = {
    status:200,
    message: "success",
    count:2,
    contacts: [
      {
        phone: "9725555555",
        lastName: "Suhy",
        firstName: "Thomas",
        email: "tsuhy@test.co",
        contactId: "003DR00000lCTZwYAO"
      },
      {
        phone:"9723456789",
        lastName:"Hierarchy",
        firstName:"Test",
        email:"test.hierarchy@test.com",
        contactId:"003DR00000lkbVKYAY"
      }
    ],
    account: {
      taxID: null,
      shippingAddress: {
        street: "14755 Preston Road, Suite 400",
        state: "TX",
        postalCode: "75254",
        country: "United States",
        city: "Dallas"
      },
      phone: "9725550123",
      companyName: "Ignite Test Customer",
      billingAddress: {
        street: null, 
        state: null,
        postalCode:null,
        country: "United States",
        city: null
      },
      accountId: "001DR00001Ni1LYYAZ"
    }
  };

  const body = JSON.stringify({
    command: 'SalesforceContactSearch',
    uuid,
    ...(employeeRefreshToken && { token: employeeRefreshToken }),
    accountId,
  });

  const response = await fetch(salesforceConfig().salesforceUrl, { method: 'POST', headers, body })
  const res = isMockMode ? mockResponse : await response.json();

  return toResponse(res);

}

export default fetchContacts;